// extracted by mini-css-extract-plugin
export default {"carouselContainer":"ImageCarousel_carouselContainer__xNf6I","carouselSlide":"ImageCarousel_carouselSlide__OiHRt","carouselImage":"ImageCarousel_carouselImage__JjaOW"};